export const getReviewActionConfig = (action, filename) => {
  const base = {
    approve: {
      heading: "Approve",
      content: `Mark ${filename} as approved`,
      btnTxtPrimary: "Approve",
    },
    approve_forward: {
      heading: "Approve & forward",
      content: `Approve ${filename} and choose the next reviewer`,
      btnTxtPrimary: "Approve & forward",
      requiresRecipient: true,
    },
    rework: {
      heading: "Request Rework",
      content: `Send ${filename} back for revision`,
      btnTxtPrimary: "Request Rework",
    },
    submit: {
      heading: "Submit Review",
      content: `Send ${filename} back for review to get approval.`,
      btnTxtPrimary: "Submit",
    },
  };

  return base[action];
};

export const REVIEW_STATUS = {
  approve: "APPROVED",
  approve_forward: "APPROVED",
  rework: "REWORK",
};